export const getLocale = locale => {
	if (locale === 'el') {
		return 'gr';
	}

	return locale;
};
